import { render, staticRenderFns } from "./loadding.vue?vue&type=template&id=066dfae7&scoped=true&"
import script from "./loadding.vue?vue&type=script&lang=js&"
export * from "./loadding.vue?vue&type=script&lang=js&"
import style0 from "./loadding.vue?vue&type=style&index=0&id=066dfae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066dfae7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
